import 'rc-steps/assets/index.css'

import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import Steps from 'rc-steps'
import { Status } from 'rc-steps/lib/interface'
import { useEffect } from 'react'
import { AiOutlineCheck, AiOutlineClose, AiOutlineEllipsis, AiOutlineLoading } from 'react-icons/ai'
import { useNavigate } from 'react-router-dom'

import logoImg from '@/assets/images/logo2.png'

const stepItems = [
  { title: '准备窗口', description: '初始化窗口' },
  {
    title: '课堂参数',
    description: '初始化参数'
  },
  {
    title: '课堂数据',
    description: '获取后台数据'
  },
  {
    title: '音视频',
    description: '启动音视频服务'
  },
  {
    title: '进入教室',
    description: '打开教室'
  }
]

interface IProps {
  step: number
  status: Status
  errorTxt: string
}

export default function Index({ step, status, errorTxt }: IProps) {
  const navigate = useNavigate()

  useEffect(() => {
    if (step < stepItems.length) {
      console.info(`%c Step${step + 1} %c ${stepItems[step].title} `, 'color: #fff; background: #5f5f5f', 'color: #fff; background: #4bc729')
    }
  }, [step])

  return (
    <Container className="bg-room bg-center bg-cover bg-no-repeat w-screen h-screen flex items-center justify-center flex-col absolute top-0 left-0 z-50">
      <img className="w-[100px] mb-[50px] opacity-5" src={logoImg} />
      <div className="w-[720px]">
        <Steps
          className=""
          stepIcon={(info) => {
            let icon = null
            let bgColor = ''
            let color = ''
            if (info.status === 'error') {
              icon = <AiOutlineClose />
              bgColor = 'bg-[#ff4d4f]'
              color = 'text-[#FFF]'
            }
            if (info.status === 'wait') {
              icon = <AiOutlineEllipsis />
              bgColor = 'bg-[#FFF]'
              color = 'text-[#316cbd]'
            }
            if (info.status === 'process') {
              icon = <AiOutlineLoading />
              bgColor = 'bg-[#FFF]'
              color = 'text-[#316cbd]'
            }
            if (info.status === 'finish') {
              icon = <AiOutlineCheck />
              bgColor = 'bg-[#316cbd]'
              color = 'text-[#FFF]'
            }
            return <div className={`rounded-full  w-full h-full flex items-center justify-center ${bgColor} ${color} ${info.status === 'process' ? 'animate-spin' : ''}`}>{icon}</div>
          }}
          size="small"
          status={status}
          current={step}
          items={stepItems}
        />
      </div>
      {errorTxt ? <div className="my-[20px] text-[#ff4d4f] text-[12px]">错误代码: {errorTxt}</div> : null}
      {status === 'error' ? (
        <div className="flex items-center justify-center gap-[0.1rem] mt-[.2rem]">
          <button onClick={() => navigate(0)} className="px-[10px] h-[30px] text-[#FFF] text-[12px] anim_btn2">
            刷新重试
          </button>
          <button
            onClick={() => {
              window.history.back()
            }}
            className="px-[10px] h-[30px] rounded bg-[#ff4d4f] text-[#FFF] text-[12px] anim_btn2"
          >
            退出教室
          </button>
        </div>
      ) : null}
    </Container>
  )
}

const Container = styled(motion.div)`
  .rc-steps-item-title {
    color: white !important;
  }
  .rc-steps-item-description {
    color: #ddd !important;
  }
`
